import { autoUpdate, computePosition, offset, platform } from '@floating-ui/dom'
import { warn } from './logger'

/**
 * Watch the position of `watchEl` and update the position of `el` accordingly.
 * @param watchEl an element to watch
 * @param el an element to update
 * @param options
 * @param options.strategy the position strategy of `el`
 * @param options.useOffset if true, `el` will be positioned using `watchEl`'s offset instead of computed position
 * @returns a function to stop watching
 */
export function setupOverlay (watchEl: HTMLElement, el: HTMLElement, options?: { useOffset?: boolean }): () => void {
  const strategy = 'absolute'
  const {
    useOffset = false
  } = options ?? {}

  el.style.setProperty('position', strategy)
  const onUpdate = async () => {
    if (useOffset) {
      const { width, height } = await platform.getDimensions(watchEl)
      el.style.setProperty('left', `${watchEl.offsetLeft}px`)
      el.style.setProperty('top', `${watchEl.offsetTop}px`)
      el.style.setProperty('width', `${width}px`)
      el.style.setProperty('height', `${height}px`)
      return
    }
    const { x, y } = await computePosition(watchEl, el, {
      placement: 'bottom',
      strategy,
      middleware: [offset(({ rects }) => {
        return {
          mainAxis: -rects.reference.height
        }
      })]
    })
    const { width, height } = await platform.getDimensions(watchEl)
    el.style.setProperty('left', `${x}px`)
    el.style.setProperty('top', `${y}px`)
    el.style.setProperty('width', `${width}px`)
    el.style.setProperty('height', `${height}px`)
  }
  onUpdate().catch(warn)
  return autoUpdate(watchEl, el, () => { onUpdate().catch(warn) })
}
